import { BROADCAST_NOTIFICATION_TYPE } from "@/entities/broadcast-notification";
import { useEventBusListener } from "@/modules/event-bus";

import { useJobModuleActionRunning } from "./job-module-action-running.hook";

const JobModuleActionRunning = () => {
  const { runAction } = useJobModuleActionRunning();

  useEventBusListener(
    BROADCAST_NOTIFICATION_TYPE.JOB_MODULE_RUNNING,
    runAction
  );

  return <></>;
};

export default JobModuleActionRunning;
